import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  badge: {
    position: 'absolute',
    top: -6,
    backgroundColor: '#FF3B30',
    borderRadius: 8,
    paddingHorizontal: 6,
    paddingVertical: 2,
  },
  right: {
    right: -40,
  },
  left: {
    left: -40,
  },
  badgeText: {
    color: '#fff',
    fontSize: 10,
    fontWeight: '700',
  },
});
